import React from 'react';
import { Helmet } from 'react-helmet';
import WStoreContainer from './WStoreContainer';
import './WStorePage.css';

function WStorePage({ location }) {
  return (
    <div className="wstore-page">
      <Helmet>
        <title>WStore</title>
      </Helmet>
      <h1 className="sr-only">WStore</h1>
      <div className="wstore-container">
        <div className="wstore-window">
          <WStoreContainer location={location} />
        </div>
      </div>
    </div>
  );
}

export default WStorePage;
